import { render, staticRenderFns } from "./NsbWithdrawal.vue?vue&type=template&id=b6676602&scoped=true&"
import script from "./NsbWithdrawal.vue?vue&type=script&lang=js&"
export * from "./NsbWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./NsbWithdrawal.vue?vue&type=style&index=0&id=b6676602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6676602",
  null
  
)

export default component.exports